import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCodEmpUser, isAdmin, isSuperAdmin } from "../api/services/AuthService";
import { setSessionExpired } from "../api/services/AuthService"


const ProtectedRoute = (props) => {
    let navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    setSessionExpired();
    const checkUserToken = () => {
        if (!getCodEmpUser) {
            setIsLoggedIn(false);
            navigate('/')
        }
        if(isAdmin() && props.viewAdmin === "false"){
            navigate('/notFound')
        }
        if(isSuperAdmin() && props.viewSuperAdmin === "false"){
            navigate('/notFound')
        }
        setIsLoggedIn(true);
    }
    useEffect(() => {
        checkUserToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);
    
    return (
        <React.Fragment>
            {
                isLoggedIn ? props.children : null
            }
        </React.Fragment>
    );
}
export default ProtectedRoute;